<script lang="ts" setup>
import CIcon from '@lib/components/CIcon/CIcon.vue'
import { computed } from 'vue'
import dayjsInstance from 'dayjs'
import relativeTimePlugin from 'dayjs/plugin/relativeTime.js'
import { useI18n } from 'vue-i18n'
import useThemeVars from '@lib/composables/useThemeVars'

const { t } = useI18n()

dayjsInstance.extend(relativeTimePlugin)

const props = defineProps<{
  canvas: any
  isDefault?: boolean
  activeCanvasId?: string
}>()

defineEmits<{
  (e: 'select-canvas', canvasId: string): void
}>()

const lastUsed = computed(() => {
  return props.canvas?.modified_at ? dayjsInstance(props.canvas.modified_at).fromNow() : '-'
})

const isSelected = computed(() => props.canvas.id === props.activeCanvasId)
const themeVars = useThemeVars()
</script>

<template>
  <div class="canvas-list-item flex p-2 cursor-pointer" @click.stop="$emit('select-canvas', canvas)">
    <div class="flex flex-col flex-1 content-center">
      <div class="canvas-list-item__title" :class="{ 'canvas-list-item__title--selected': isSelected }">
        {{ canvas.name || '-' }}
      </div>
      <div v-if="canvas.subtitle" class="canvas-list-item__subtitle my-1">{{ canvas.subtitle }}</div>
      <div v-if="lastUsed && !canvas.subtitle" class="canvas-list-item__description mt-1">
        {{ t('canvasUI.CCanvasSelector.edited') }} {{ lastUsed }}
      </div>
    </div>
    <div class="flex items-center pr-3">
      <CIcon v-if="isSelected" fa-type="fas" icon="check" :size="16" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.canvas-list-item {
  background-color: v-bind('themeVars.primary6');
  min-height: 50px;
  color: v-bind('themeVars.text');
  line-height: 1rem;

  &__title--selected {
    font-weight: 600;
  }

  &__subtitle {
    color: v-bind('themeVars.primary');
  }

  &__description {
    font-size: 0.75rem;
    line-height: 0.875rem;
    color: v-bind('themeVars.text3');
  }
}
</style>
